import * as THREE from "three";

/**
 * ONE off-screen Three.js WebGL renderer for CPU readback thumbnails (material sphere snapshots,
 * mesh asset PNG previews). The main viewport uses its own WebGL canvas; without this pooling,
 * each subsystem would mint a separate context and browsers hit "Too many active WebGL contexts".
 */
let rendererInst: THREE.WebGLRenderer | null = null;

let chain: Promise<unknown> = Promise.resolve();

export function getSharedHeadlessWebglThreeRenderer(): THREE.WebGLRenderer {
  if (!rendererInst) {
    rendererInst = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
      powerPreference: "low-power",
      premultipliedAlpha: false,
    });
    rendererInst.setPixelRatio(1);
    rendererInst.outputColorSpace = THREE.SRGBColorSpace;
    rendererInst.toneMapping = THREE.ACESFilmicToneMapping;
    rendererInst.toneMappingExposure = 1;
    rendererInst.setClearColor(0x000000, 0);
  }
  return rendererInst;
}

/**
 * Serializes work that renders with {@link getSharedHeadlessWebglThreeRenderer} — required because
 * all callers share GPU state on that single GL context.
 */
export function runHeadlessExclusive<T>(task: () => T | Promise<T>): Promise<T> {
  const done = chain.then(() => task()) as Promise<T>;
  chain = done.then(
    () => undefined,
    () => undefined
  );
  return done;
}
